import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import ReactMarkdown from 'react-markdown';
import { useIntl } from 'react-intl';
import rehypeSlug from 'rehype-slug';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import markdown from '../data/staticPages/conditions.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';

const ConditionsPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="conditions"
      passHref
    >
      {intl.formatMessage(messages['termsAndConditions.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['termsAndConditions.title'])}
        description={intl.formatMessage(messages['termsAndConditions.title'])}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
        )}
        title={intl.formatMessage(messages['termsAndConditions.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

ConditionsPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default ConditionsPage;
